import React from "react";
import { SEOHelmet } from "../components/common/SEOHelmet";
import groupsData from "../data/groups.json";
import { Group } from "../types/group";
import { GroupCard } from "../components/common/GroupCard";

export default function GroupTherapyPage() {
  const groups = (groupsData as { groups: Group[] }).groups;

  return (
    <>
      <SEOHelmet page="gruppentherapie" />

      <section aria-labelledby="groups-heading">
        <header className="mb-8 sm:mb-12">
          <h1
            id="groups-heading"
            className="text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight text-gray-900 dark:text-white drop-shadow-sm"
          >
            Gruppentherapien
          </h1>
          <p className="mt-4 text-base sm:text-lg text-gray-600 dark:text-gray-300 max-w-3xl">
            Entdecken Sie unsere aktuellen Gruppentherapie-Angebote. Klicken Sie eine Gruppe um die PDF herunterzuladen.
          </p>
        </header>

        {groups.length === 0 ? (
          <p className="text-gray-600 dark:text-gray-300">Aktuell sind keine Gruppen eingetragen.</p>
        ) : (
          <div className="grid gap-6 sm:gap-8 grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
            {groups.map((g) => (
              <GroupCard key={g.id} group={g} />
            ))}
          </div>
        )}
      </section>
    </>
  );
}


